import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
    name: 'dark',
    color: {
        /* Background / Surface */
        primary_50: '#1C212B',
        primary_100: '#151922',
        primary_200: '#0F1218',
        primary_300: '#2A303B',
        primary_400: '#566070',

        /* Accent */
        point_y_100: '#6D8DFF',
        point_y_200: '#8EA2FF',
        point_y_300: '#A8B3C7',

        point_n_100: '#F97066',
        point_n_200: '#D92D20',
        point_n_300: '#B42318',

        /* Text */
        text_color_100: '#F5F7FA',
        text_color_200: '#D8DEE8',
        text_color_300: '#9AA4B2',
        text_color_400: '#6D7786',
    }
}

export const lightTheme: DefaultTheme = {
  name: 'light',
  color: {

    /* Background / Surface */
    primary_50: '#F5F6F7',
    primary_100: '#FBFBFA',
    primary_200: '#F2F3F5',
    primary_300: '#D5D9E0',
    primary_400: '#808B9A',

    /* Accent */
    point_y_100: '#3D59B6',
    point_y_200: '#5470C8',
    point_y_300: '#667085',

    /* Negative / Danger */
    point_n_100: '#C03D34',
    point_n_200: '#A8322B',
    point_n_300: '#8D2925',

    /* Text */
    text_color_100: '#252A33',
    text_color_200: '#454E5C',
    text_color_300: '#697586',
    text_color_400: '#9099A8',
  }
};
